import React, { useEffect, useState, useCallback } from 'react'
import { Alert, Spinner } from 'react-bootstrap'
import { ContentArea } from '../../components/Page/logix2020/ContentArea'
import { Subheader } from '../../components/Page/logix2020/Subheader'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import useStores from '../../stores/useStore'
import { useTranslation } from 'react-i18next'
import BigFooter from '../../components/Footer/BigFooter'
import { useLocation } from 'react-router-dom'
import { FlexWrapper } from '../../components/Page/logix2020/FlexWrapper'
import { SidebarLeft } from '../../components/Page/logix2020/SidebarLeft'
import SidebarNavigation from '../../components/Page/logix2020/SidebarNavigation'
import i18n from '../../translation/i18n'
import WashSettings from '../../components/Wash/Configuration/WashSettings'
import WashReports from '../../components/Wash/Reports/WashReports'
import WashStationData from '../../components/Wash/Configuration/WashStationData'
import Disposal from '../../components/Wash/Disposal'
import JobScan from '../../components/Wash/JobScan'
import Recapturing from '../../components/Wash/Recapturing'
import { Observer } from 'mobx-react'
import instMgmtApi from '../../utils/api/instanceMgmt/instMgmtApi'
import { useNavigate } from 'react-router-dom'
import { useObserver } from 'mobx-react'

const navigationLeft = () => [
    {
        key: '#main',
        to: '#main',
        name: i18n.t('washPage:main'),
        disabled: false,
    },
    {
        key: '#recapturing',
        to: '#recapturing',
        name: i18n.t('washPage:recapturing'),
        disabled: false,
    },
    {
        key: '#disposed',
        to: '#disposed',
        name: i18n.t('washPage:disposed'),
        disabled: false,
    },
    {
        key: '#reports',
        to: '#reports',
        name: i18n.t('washPage:reports'),
        disabled: false,
    },
    {
        key: '#settings',
        to: '#settings',
        name: i18n.t('washPage:settings'),
        disabled: false,
    },
]

const WashPageContent = () => {
    const { washStore, uiStore } = useStores()
    const currentLocation = useLocation()
    const { t } = useTranslation()
    const [activeNav, setActiveNav] = useState('')
    const navigate = useNavigate()
    const allowWashRecapturingScancode = useObserver(
        () => uiStore.allowWashRecapturingScancode
      )
    const checkWashIsInitialized = useCallback(async () => {
        washStore.setEnforceInitWash(false)
        var result = await instMgmtApi.checkWashIsInitialized()
        washStore.setEnforceInitWash(!result)
        if (washStore.enforceInitWash) {
            setActiveNav('#settings')
        }
    }, [washStore])
    const initWashStation = useCallback(async () => {
        washStore.getHideScanAfterTime()
        washStore.getSelectedWashStationId()
        await washStore.loadWashStation(true)
    }, [washStore])
    useEffect(() => {
        let curLoc = currentLocation.hash || '#main'
        if (curLoc === '#main' || curLoc === '#disposed' || curLoc === '#newcapture') {
            washStore.checkWashStationSelection()
        }
        setActiveNav(curLoc)
    }, [currentLocation.hash, washStore])
    useEffect(() => {
        checkWashIsInitialized()
    }, [checkWashIsInitialized])
    useEffect(() => {
        initWashStation()
    }, [initWashStation])
    useEffect(() => {
        if (washStore.enforceInitWash && activeNav !== '#settings') {
            navigate('#settings')
        }
    }, [activeNav, washStore.enforceInitWash, navigate])
    const getOptions = () => {
        let options = navigationLeft()
        if (!allowWashRecapturingScancode)
          options = options.filter((item) => item.key !== '#recapturing')

        return options
      }
    return <Observer>{() => (
        <div>
            <Subheader className='subHeader-v1'>
                <div className='subheader-title flex-grow-1'>
                    {t('washPage:laundry')}
                </div>
                <div className="flex-grow-1" />
                <WashStationData />
            </Subheader>
            <FlexWrapper>
                <SidebarLeft>
                    <SidebarNavigation options={getOptions()} active={activeNav} />
                </SidebarLeft>
                <ContentArea>
                    {activeNav === '#main' && <JobScan/>}
                    {activeNav === '#recapturing' && <Recapturing/>}              
                    {activeNav === '#disposed' && <Disposal/>}
                    {activeNav === '#settings' && <WashSettings/>}
                    {activeNav === '#reports' && <WashReports />}
                </ContentArea>
            </FlexWrapper>
            <BigFooter />
        </div>
    )}</Observer>
}

const WashPage = () => {
    const { uiStore } = useStores()
    const { t } = useTranslation()

    return <Observer>{() => (
        <>
            {!uiStore.showWash ? (
                <>
                    <Subheader className='subHeader-v1'>
                        <div className='subheader-title'>
                            {t('WashPage:laundry')}
                        </div>
                    </Subheader>
                    {!!uiStore.dashboard ? (
                        <Alert variant='danger'>{t('WashPage:accessDenied')}</Alert>
                    ) : (
                        <div className='d-flex align-items-center justify-content-center'>
                            <Spinner animation='border' variant='primary' />
                        </div>
                    )}
                </>
            ) : (
                <WashPageContent />
            )}
        </>
    )}</Observer>
}
export default WashPage
